import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCustomerQR, updateCustomerQR } from "../api";

export const useGetCustomerQR = (id, enabled = true) => {
  const { data, isLoading, status, isError, error, isSuccess } = useQuery({
    queryKey: ["customer-qr", id],
    queryFn: () => getCustomerQR(id),
    enabled: !!id && enabled,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  return {
    data,
    status,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};

export const useUpdateCustomerQR = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, data }) => updateCustomerQR(id, data),
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({ queryKey: ["customer-qr", variables.id] });

    },
    onError: (error) => {
      console.error("Error updating customer QR:", error);

      // Log error
      let errorMessage = 'Error submitting form. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      console.error(errorMessage);
    },
  });

  return mutation;
};

